var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (['hungaryMap'].indexOf(_vm.$route.name) > -1)?_c('div',[_c('cbr-hu-map',{attrs:{"show":true}})],1):_c('div',[_c('cbr-solo-map',{attrs:{"show":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4bdf82a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/IframeMapHolder.vue
// module id = 230
// module chunks = 0